/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    VehicleOrderDto,
    VehicleOrderDtoFromJSON,
    VehicleOrderDtoFromJSONTyped,
    VehicleOrderDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface VehicleOrderResponse
 */
export interface VehicleOrderResponse {
    /**
     * 
     * @type {Array<VehicleOrderDto>}
     * @memberof VehicleOrderResponse
     */
    all: Array<VehicleOrderDto>;
    /**
     * 
     * @type {number}
     * @memberof VehicleOrderResponse
     */
    totalCount: number;
}

export function VehicleOrderResponseFromJSON(json: any): VehicleOrderResponse {
    return VehicleOrderResponseFromJSONTyped(json, false);
}

export function VehicleOrderResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleOrderResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'all': ((json['all'] as Array<any>).map(VehicleOrderDtoFromJSON)),
        'totalCount': json['totalCount'],
    };
}

export function VehicleOrderResponseToJSON(value?: VehicleOrderResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'all': ((value.all as Array<any>).map(VehicleOrderDtoToJSON)),
        'totalCount': value.totalCount,
    };
}


